import React from 'react';

export const Images = () => {
    return <div>Images</div>;
};
